<script>
	import { control } from '../global.js'
	import { createEventDispatcher } from 'svelte'

	export let tabname = control.tabname
	export let rpp = control.rpp
	export let page = control.page
	export let pkname = control.pkname
	export let datos = '*'

	let  tabstruct = [] 

	let filtro = {}

	$: fetchdata = async() => {
		let query = ''
		if(pkname===''){
			query = `select top ${rpp} ${datos} from ${tabname} `
		}else{
			query = `select t.* from 
				(select ROW_NUMBER() OVER(ORDER BY ${pkname} asc) as _rownum,${datos} from ${tabname} ) t 
				where t._rownum between ((${page}*${rpp})+1) and ((${page}+1)*${rpp})`
		}

		const res = await fetch(`${control.api}/exec-query?u=${control.update}`,
			{
				method:'POST',
				headers: control.headers,
				body:JSON.stringify({query})	
			})
		const data = await res.json()
		tabstruct = (Object.keys(data.data[0]))
		
		if(res.ok) return data.data || []
		else {
			throw new Error(data)
		}
	}

</script>

<div class="container-fluid">
	
	<h5>Browse: {tabname}</h5>

	{#await fetchdata()}
		<p>Fetching data....</p>
	{:then rs}
		{#if pkname!==''}
			<button on:click={()=>page=page>0?page-1:0}>&lt;</button>
			<button on:click={()=>page=page+1}>&gt;</button>
			<button on:click={()=>control.update=!control.update}>&orarr;</button>
		{/if}
		<div class="row py-2 mt-2 border-bottom bg-secondary text-white">
			{#each tabstruct as reg, index}
				<div class="col fw-bold">
					{#if reg.substr(0,1)==='_'}
						#
					{:else}
						{reg.toUpperCase()}
					{/if}
				</div>
			{/each}
		</div>
		<!-- filtro -->
		<div class="row py-2 border-bottom bg-light">
			{#each tabstruct as reg, index}
				<div class="col fw-bold">
					{#if reg.substr(0,1)!=='_'}
						<input class="form-control" bind:value={filtro[reg]}>
					{:else}
						<span>&nbsp;</span>
					{/if}
				</div>
			{/each}
		</div>

		{#each rs as item, index}
			<div class="row py-1 border-bottom">
				{#each tabstruct as reg, index}
					<div class="col">{item[reg]}</div>
				{/each}
			</div>

		{/each}
		
	{/await}
</div>